import { GetEntraUserDataDocument, SsoProvider } from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { computed, Ref, toValue } from 'vue';

export function useGetUserEntraData(oid: Ref<string>, provider: Ref<SsoProvider>) {
    const getDataQuery = useQuery(
        GetEntraUserDataDocument,
        () => ({ oid: toValue(oid), provider: toValue(provider) }),
        () => ({
            enabled: !!toValue(oid) && !!toValue(provider),
        }),
    );

    const user = computed(() => getDataQuery.result.value?.getEntraUserData?.user ?? undefined);
    const errors = computed(() => getDataQuery.result.value?.getEntraUserData?.errors ?? undefined);

    return {
        user,
        errors,
        loading: getDataQuery.loading,
    };
}
